module.exports = __webpack_public_path__ + "res/map.e2d111f4449ac056e6c436bc2f1eb7ae.webp";